/* eslint-disable max-len */
export default {
    text: 'Diese Seite verwendet Cookies, zwecks der Erbringung von Leistungen gemäß den',
    privacy: 'Datenschutzbestimmungen.',
    button: 'OK'
};



// WEBPACK FOOTER //
// ./src/i18n/de/cookie.js